import BankIdLogo from "../bankId/BankID_logo_white.svg?react";

const BankIdIcon = ({ width }) => {
  return <BankIdLogo width={width} />;
};

export default BankIdIcon;
